<template>
  <v-card class="my-4">
    <v-card-title class="card-title-variations"> Dados Produto Loja </v-card-title>
    <v-row class="px-8">
      <v-divider></v-divider>
    </v-row>
    <v-card-text class="card-info px-10">
      <v-row>
        <v-col cols="4">
          <h3 class="pb-2">Lojas</h3>
          <mf-select-units-dialog
            id="campaign-units"
            outlined
            :selected-units.sync="selectedUnit"
            :unit-error="validation.product.storeId && validation.product.storeId.$error"
            :units="units"
            :tag-list="tagList"
            :group-list="unitsGroups"
            single-select
          />
        </v-col>
        <v-col cols="4" offset="1">
          <h3 class="pb-2">Nome</h3>
          <v-text-field
            v-model="productForms.name"
            label="Nome"
            outlined
            height="44px"
            :error="validation.product.name && validation.product.name.$error"
            :error-messages="nameError"
          />
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="mt-2">
        <v-col cols="4">
          <h3 class="pb-2">Código interno / SKU</h3>
          <v-text-field
            v-model="productForms.sku"
            type="number"
            class="hidden-arrows"
            label="Código"
            outlined
            dense
            :disabled="editSku"
            :error="validation.product.sku && validation.product.sku.$error"
            :error-messages="skuError"
            @blur="removeSpecialCaracter"
            @keydown="$event.key === '-' ? $event.preventDefault() : null"
          />
        </v-col>
        <v-col cols="4" offset="1">
          <h3 class="pb-2">EANs</h3>
          <v-chip-group v-if="!!productForms.eans.length" column show-arrows active-class="primary--text">
            <div v-for="(ean, index) in productForms.eans" :key="index">
              <v-chip color="#F6F6F8" :class="ean.isMain ? 'chip-isMain' : ''" :ripple="false">
                <span class="column-title">
                  <b class="">{{ ean.ean }}</b>
                </span>
              </v-chip>
              <div v-if="ean.packingQuantity && ean.packingQuantity.quantityPackaging" class="mr-4">
                <span class="small-text-regular-font m-1">Pacote: {{ ean.packingQuantity.quantityPackaging }}</span>
              </div>
            </div>
          </v-chip-group>
          <div v-else>
            <mf-button icon="add" text label="Adicionar EAN" color="marca-0-l40" @click="addEans" />
          </div>
          <div v-if="eanError" class="pt-1 error--text v-messages">
            <span class="v-messages__message">Adicione pelo menos 1 ean</span>
          </div>
          <mf-button v-if="productForms.eans.length" text label="Configurar EANs" color="marca-0-l40" @click="addEans" />
        </v-col>
      </v-row>
    </v-card-text>
    <product-eans-table v-model="productForms" :openDialog.sync="openDialog" />
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProductEansTable from '../../components/ProductEansTable.vue'

export default {
  name: 'ProductStoreInfo',
  components: {
    ProductEansTable,
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showAllEans: false,
    openDialog: false,
    selectedMeasure: {},
    selectedUnit: [],
  }),
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    editSku() {
      if (!this.isCreate) {
        return !this.productForms.manuallyEdited
      }
      return false
    },
    eanError() {
      return this.validation.product.eans && this.validation.product.eans.$error
    },
    storeNameError() {
      if (this.validation.product.store.name && this.validation.product.store.name.$error) return 'Campo obrigatório'
      return ''
    },
    nameError() {
      if (this.validation.product.name && this.validation.product.name.$error) {
        if (!this.validation.product.name.maxLength) return 'Deve conter no máximo 255 caracteres'
        return 'Campo obrigatório'
      }
      return ''
    },
    skuError() {
      if (this.validation?.product?.sku?.$error && !this.validation?.product?.sku?.required) return 'Campo obrigatório'
      if (this.validation?.product?.sku?.$error && !this.validation?.product?.sku?.maxLength) return 'O SKU deve conter no máximo 14 caracteres.'
      return ''
    },
  },
  watch: {
    selectedUnit(value) {
      if (value.length > 0) {
        const completUnit = this.units.find((unit) => unit.id_erp === value[0])
        this.productForms.storeId = completUnit._id
      } else {
        this.productForms.storeId = ''
      }
    },
  },
  async mounted() {
    await this.fetchUnits().then(() => {
      this.selectUnit()
    })
  },
  methods: {
    ...mapActions(['fetchUnits']),
    addEans() {
      this.openDialog = true
    },
    removeSpecialCaracter() {
      if (/-/.test(this.productForms.sku)) {
        this.productForms.sku = this.productForms.sku.replace(/[^\w\s]/g, '')
      }
    },
    selectUnit() {
      const unit = this.units.find((unit) => unit._id === this.productForms.storeId)

      if (unit) {
        this.selectedUnit.push(unit.id_erp)
      }
    },
  },
}
</script>

<style lang="scss">
.card-info {
  .v-text-field--filled > .v-input__control > .v-input__slot,
  .v-text-field--full-width > .v-input__control > .v-input__slot,
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 44px !important;
    height: 44px;
  }

  .v-text-field--outlined .v-label {
    top: 12px !important;
  }
  .chip-isMain {
    border: 2px solid $marca-0-l30 !important;
    color: $marca-0-l10 !important;
  }

  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__prepend-outer {
    margin-top: 11px;
  }

  .img-size {
    width: 50px;
    height: 50px;
  }
  .card-border {
    border: 1px solid $cinza-l60 !important;
    border-radius: 4px;
  }
  .hidden-arrows {
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      margin: 0 !important;
    }
    input[type='number'] {
      -moz-appearance: textfield !important;
    }
  }
}
</style>
